import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

// Styles
import {
  Wrapper,
  Index,
  Label,
  Meta
} from './LeaderboardItemStyles';

const LeaderboardItem = ({ index, meta, slug, title }) => (
  <Wrapper>
    <Index>{index}</Index>
    <Label>{slug ? <Link to={`/${slug}/`}>{title}</Link> : title}{meta && (<Meta>{meta}</Meta>)}</Label>
  </Wrapper>
);

LeaderboardItem.propTypes = {
  index: PropTypes.number.isRequired,
  meta: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  slug: PropTypes.string
};

LeaderboardItem.defaultProps = {
  description: '',
  slug: '',
  meta: null
};

export default LeaderboardItem;



// WEBPACK FOOTER //
// ./src/components/LeaderboardItem/LeaderboardItem.jsx